var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParametersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 10.0001L23.3333 10.0001L23.3333 8.33344H21.6666V10.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.0001L16.6666 10.0001L16.6666 8.33344H18.3333V10.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.3334H31.6666V16.6667L29.9999 16.6668L30 18.3334Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3334H8.33329V16.6667H9.99996V18.3334Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.3334H31.6666L31.6666 21.6668L30 21.6667V23.3334Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 23.3334H8.33329L8.33329 21.6668L9.99996 21.6667V23.3334Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 31.6667L23.3333 31.6668L23.3333 30.0001L21.6666 30.0001L21.6666 31.6667Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 31.6667L16.6666 31.6668L16.6666 30.0001L18.3333 30.0001L18.3333 31.6667Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.6667H23.3333V23.3334H25V16.6667Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16.6667L23.3333 15.0001H16.6666L16.6666 16.6667H23.3333Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6667H15V23.3334H16.6666V16.6667Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 25.0001L23.3333 23.3334H16.6666L16.6666 25.0001H23.3333Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 28.3334L11.6666 30.0001H16.6666V28.3334L11.6666 28.3334Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 28.3334H11.6666V23.3334L9.99996 23.3334L9.99995 28.3334Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 18.3334L6.66663 18.3334V21.6668H8.33329L8.33329 18.3334Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 16.6667L11.6666 16.6668L11.6666 11.6668L9.99995 11.6667L9.99996 16.6667Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 11.6668V10.0001H11.6666V11.6668H16.6666Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 8.33344L21.6666 6.66675H18.3333L18.3333 8.33344H21.6666Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 10.0001V11.6668H28.3333V10.0001H23.3333Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 16.6668H29.9999V11.6667L28.3333 11.6668L28.3333 16.6668Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 18.3334L31.6666 18.3334L31.6666 21.6668H33.3333V18.3334Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 28.3334H29.9999L30 23.3334L28.3333 23.3334V28.3334Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 30.0001L28.3333 28.3334L23.3333 28.3334V30.0001H28.3333Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 33.3334V31.6667H18.3333V33.3334H21.6666Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6666 11.6668H16.6666V10.0002H18.3333V8.3335H21.6666V10.0002H23.3333V11.6668H28.3333V16.6668H29.9999V18.3335H31.6666V21.6668H29.9999V23.3335H28.3333V28.3335H23.3333V30.0002H21.6666V31.6668H18.3333V30.0002H16.6666V28.3335H11.6666V23.3335H9.99992V21.6668H8.33325V18.3335H9.99992V16.6668H11.6666V11.6668ZM16.6666 15.0002V16.6668H14.9999V23.3335H16.6666V25.0002H23.3333V23.3335H24.9999V16.6668H23.3333V15.0002H16.6666Z",
    fill: "#FFFFF3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametersIcon);
export default __webpack_public_path__ + "static/media/parameters_icon.fb376a937d763bd3362de25fc09bd948.svg";
export { ForwardRef as ReactComponent };